/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/** @jsxImportSource @emotion/react */
import {useEffect, useState} from 'react';

import {css} from '@emotion/react';
import {batch, useDispatch} from 'react-redux';

import {showLoading, updateLoading} from '@/actions/loadingActions';
import {showAlert} from '@/actions/setupActions';
import {GetRequest, PutRequest} from '@/api/request';
import {TARE as API_TARE, IS_DONE, DO_TARE} from '@/constants/apis';
import {roundCorner, proteinConcentrationUnactiveColor, ButtonColor, fontSize} from '@/constants/appStyle';
import {ALERT_TYPE, TARE_STAGE_ENUM} from '@/constants/enums';
import {ProteinTube, BufferTube} from '@/constants/jsonKeys';
import {CALIBRATION_LOAD_CELL_WIZARD} from '@/constants/messages';
import {FONT_SIZE as FontSize, CANCEL as CancelLabel} from '@/constants/pcConstAppData';
import UseIsDemoMode from '@/hooks/useIsDemoMode';

import {VOLUME_SENSOR_LABEL} from '../../../constants/calibrationWizardConstant';

let TareStatusSubscriber = null;

function TareButton(props) {
  const [isTare, setIsTare] = useState(false);
  const isDemoMode = UseIsDemoMode();
  const dispatch = useDispatch();

  useEffect(
    () => () => {
      if (TareStatusSubscriber) clearInterval(TareStatusSubscriber);
    },
    [],
  );

  const OnTareActionHandler = () => {
    // PutRequest(API_TARE).then(
    const tareStage = {
      Stage: TARE_STAGE_ENUM.CheckScale,
    };
    PutRequest(DO_TARE, tareStage).then((response) => {
      if (response.data[VOLUME_SENSOR_LABEL.Protein] && response.data[VOLUME_SENSOR_LABEL.Buffer]) OnExecuteTare();
      else
        dispatch(
          showAlert({
            alertShow: true,
            alertText: CALIBRATION_LOAD_CELL_WIZARD.TARE_FAILED_TEXT,
            alertStyle: ALERT_TYPE.ALERT_DANGER,
          }),
        );
    });
  };

  const OnExecuteTare = () => {
    setIsTare(true);
    dispatch(
      updateLoading({
        showLoading: true,
        loadingText: CALIBRATION_LOAD_CELL_WIZARD.TARE_LOADING,
        loadingClickEvent: undefined,
        loadingButton1: {
          label: CancelLabel,
          onClick: () => dispatch(showLoading(false)),
        },
      }),
    );
    TareStatusSubscriber = setInterval(() => {
      GetRequest(API_TARE + IS_DONE).then((response) => {
        if (response.data[ProteinTube].IsDone && response.data[BufferTube].IsDone) ValidateTareIsDone();
      });
    }, 500);
  };

  const ValidateTareIsDone = () => {
    batch(() => {
      dispatch(updateLoading({showLoading: false}));
      dispatch(
        showAlert({
          alertShow: true,
          alertText: CALIBRATION_LOAD_CELL_WIZARD.TARE_SUCCESS_TEXT,
          alertStyle: ALERT_TYPE.ALERT_SUCCESS,
        }),
      );
      if (TareStatusSubscriber) clearInterval(TareStatusSubscriber);
      setIsTare(false);
    });
  };

  const TareButtonStyle = css({
    height: '50px',
    width: '200px',
    textAlign: 'center',
    fontSize: parseInt(window.localStorage.getItem(FontSize), 10) || fontSize,
    borderRadius: roundCorner,
    color: '#f67400',
    backgroundColor: proteinConcentrationUnactiveColor,

    ':disabled': {
      color: ButtonColor.secondaryButtonBackgroundColorDisable,
      backgroundColor: ButtonColor.secondaryButtonColorDisabled,
    },
  });

  return (
    <button
      type="button"
      css={TareButtonStyle}
      onClick={OnTareActionHandler}
      disabled={isDemoMode || isTare || props.disabledTare}
    >
      {props.children}
    </button>
  );
}
export default TareButton;
